import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import PlayerCarouselComponent from './js/multimedia-carousel.component';

ComponentsFactory.getInstance().define('multimedia-carousel', PlayerCarouselComponent);
